import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {  IconButton, Modal, Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Card , CardHeader, CardContent, Typography, TextField, Checkbox,TextareaAutosize} from '@mui/material';
import Table from 'react-bootstrap/Table';
import {Button} from "react-bootstrap";
import { Pagination } from "react-bootstrap";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Icon from "@mui/material/Icon";
import CloseIcon from '@mui/icons-material/Close';
import "layouts/style.css"
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import Select from "react-select";
import { fetchMaterials } from "assets/globalAPI/apiGlobal";
import { approveMaterial } from "assets/globalAPI/apiGlobal";
import { createMaterial } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchRoleMaster } from "assets/globalAPI/apiGlobal";
import { createRoleMaster } from "assets/globalAPI/apiGlobal";

const RoleMaster = () => {
 const toastId = React.useRef(null);
 const [isActive, setIsActive] = useState(false);
 const navigate = useNavigate();
 const capitalizeHeader = (header) => {
    return header
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
  };

   const [currentPage, setCurrentPage]= useState(1);
   const [totalPages, setTotalPages]= useState(1);
   const [roles, setRoles] = useState([]); // Stores fetched roles
  const [selectedRole, setSelectedRole] = useState(null); // Currently selected role
  const [roleName, setRoleName] = useState("");
  const [permissions, setPermissions] = useState({
    customer_view: 0,
    customer_approval: 0,
    customer_edit:0,
    material_view: 0,
    material_approval: 0,
    material_create: 0,
    vendor_view: 0,
    vendor_approval: 0,
    vendor_edit:0,
  });

  const fetchRoles = async () => {
    try {
      const response = await fetchRoleMaster(); // Replace with your API
      const res= response.data;
      if(res.status){
          setRoles(res.data);
        console.log("Roles fetched successfully:", res.data);
      }else{
        console.log("Roles not fetched>> ", res)
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchRoles()
  }, []);

//   const handleRoleChange = (selected) => {
//     const role = roles.find((r) => r.role_id === selected.value);
//     if (role) {
//       setSelectedRole(role.role_name);
//       setPermissions({ ...role });
//     }
//   };

const handleCheckboxChange = (field) => {
    setPermissions((prev) => {
        const updatedPermissions = { ...prev };

        // Toggle the clicked checkbox
        updatedPermissions[field] = updatedPermissions[field] ? 0 : 1;

        // If the changed field is an "approval" checkbox, ensure "view" is also checked
        if (field.includes("_approval") && updatedPermissions[field] === 1) {
            const viewField = field.replace("_approval", "_view"); // Get corresponding view field
            updatedPermissions[viewField] = 1;
        }

        // If the changed field is a "view" checkbox and it gets unchecked, also uncheck "approval"
        if (field.includes("_view") && updatedPermissions[field] === 0) {
            const approvalField = field.replace("_view", "_approval"); // Get corresponding approval field
            updatedPermissions[approvalField] = 0;
        }

        return updatedPermissions;
    });
};



  const handleSave = async () => {
    setIsActive(true)
    
    if (!roleName.trim()) {
        if(!toast.isActive(toastId.current)){
                                    toastId.current= toast.error("Please Enter A Role Name",{
                                    className:"small-toast"
                                    })
                                }
        setIsActive(false);
        return;
    }

    // Remove role_id before sending
    const { role_id, ...payload } = permissions;
    payload.role_name = roleName;  

    const body={
        role_name:roleName,
        customer_view: permissions.customer_view,
    customer_approval: permissions.customer_approval,
    customer_edit: permissions.customer_edit,
    material_view: permissions.material_view,
    material_approval: permissions.material_approval,
    material_create: permissions.material_create,
    vendor_view: permissions.vendor_view,
    vendor_approval: permissions.vendor_approval,
    vendor_edit: permissions.vendor_edit,
    }

    console.log("Sending Payload:", body); // Debugging

    try {
      const response = await createRoleMaster(body)
        const res= response.data;
        if(res.status){
            console.log("what went in body>> ", body)
            console.log("Role created successfully:", res);
            setIsActive(false)
            if(!toast.isActive(toastId.current)){
                        toastId.current= toast.success(res.message,{
                        className:"small-toast"
                        })
                    }
                    setRoleName("");
                    setPermissions({
                        customer_view: 0,
                        customer_approval: 0,
                        material_view: 0,
                        material_approval: 0,
                        material_create: 0,
                        vendor_view: 0,
                        vendor_approval: 0,
                    });
        }else{
            console.log("Role not created>> ", res)
            setIsActive(false)
            if(!toast.isActive(toastId.current)){
                        toastId.current= toast.warning(res.message,{
                        className:"small-toast"
                        })
        }
    }
    } catch (error) {
      console.error("Error updating permissions:", error);
      setIsActive(false)
      if(error.response?.status==403){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Your Session has expired",{
            className:"small-toast"
          })
        }
        setTimeout(()=>{
          navigate("/")
          localStorage.clear();
        },2000)
        return;
      }
      if(!toast.isActive(toastId.current)){
        toastId.current= toast.warning(error.message,{
        className:"small-toast"
        })
}
    }
  };

   return(
    <DashboardLayout>
        <DashboardNavbar/>
        <ToastContainer />
        <SimpleBackdrop openLoader={isActive}/>
        <div style={{ marginBottom: "10px", textAlign: "left" }}>
        <SoftInput
        placeholder="Enter Role Name"
          value={roleName}
          onChange={(e) => setRoleName(e.target.value)}
          style={{ width: "200px" }}
        />
      </div>
<div style={{overflowX: "auto", marginTop: "20px"}}>
      <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
        <thead>
          <tr style={{ color: "white", backgroundColor: "#3498db" }}>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              MODULE
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0", textAlign: "center" }}>
              VIEW
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0", textAlign: "center" }}>
              CREATE
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0", textAlign: "center" }}>
              APPROVAL
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0", textAlign: "center" }}>
              EDIT
            </th>
          </tr>
        </thead>
        <tbody>
          {["customer", "material", "vendor"].map((module) => (
            <tr key={module} style={{ fontSize: "12px" }}>
              <td>{module.toUpperCase()}</td>
              <td style={{textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={permissions[`${module}_view`] === 1}
                  onChange={() => handleCheckboxChange(`${module}_view`)}
                />
              </td>
              <td style={{textAlign: "center" }}>
                {module==="material" &&
                
                <input
                  type="checkbox"
                  checked={permissions[`${module}_create`] === 1}
                  onChange={() => handleCheckboxChange(`${module}_create`)}
                />
                }
              </td>
              <td style={{textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={permissions[`${module}_approval`] === 1}
                  onChange={() => handleCheckboxChange(`${module}_approval`)}
                />
              </td>
              <td style={{textAlign: "center" }}>
                {module!=="material" &&
                
                <input
                  type="checkbox"
                  checked={permissions[`${module}_edit`] === 1}
                  onChange={() => handleCheckboxChange(`${module}_edit`)}
                />
                }
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
</div>
      <Button variant="primary" onClick={handleSave}>
        Save Changes
      </Button>

    </DashboardLayout>
   )

}

export default RoleMaster;